import api from "./api";

const SESSION_KEY = "vyapaar_session_id";
const UTM_KEY = "vyapaar_utm";

function uuid() {
    return "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getSessionId() {
    let sid = sessionStorage.getItem(SESSION_KEY);
    if (!sid) {
        sid = uuid();
        sessionStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
}

export function captureUtm() {
    try {
        const url = new URL(window.location.href);
        const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"];
        const captured = {};
        let hasAny = false;
        keys.forEach((k) => {
            const v = url.searchParams.get(k);
            if (v) { captured[k] = v; hasAny = true; }
        });
        if (hasAny) {
            const existing = JSON.parse(localStorage.getItem(UTM_KEY) || "{}");
            localStorage.setItem(UTM_KEY, JSON.stringify({ ...existing, ...captured, ts: Date.now() }));
        }
    } catch (_) {}
}

// Fire-and-forget storefront interaction tracking for a public business.
export async function trackBusinessEvent(slug, type) {
    try { await api.post(`/public/business/${slug}/event`, { type }); } catch (_) {}
}

// Kept for App.js route effect compatibility (no backend analytics for marketing site).
export function trackEvent() {}
